"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const lang_1 = require("../../../lib/lang");
if (process.env.BROWSER) {
    require('./index.less');
}
class CommentEmpty extends React.PureComponent {
    render() {
        return React.createElement("div", { className: 'comment-empty' },
            React.createElement("div", { className: 'comment-empty-image' }),
            React.createElement("div", { className: 'comment-empty-message' }, lang_1.__('widgetCommentList.noComment')));
    }
}
exports.default = CommentEmpty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQkFBK0I7QUFDL0IsNENBQXVDO0FBQ3ZDLElBQUksT0FBTyxDQUFDLEdBQUcsQ0FBQyxPQUFPLEVBQUU7SUFDckIsT0FBTyxDQUFDLGNBQWMsQ0FBQyxDQUFDO0NBQzNCO0FBSUQsTUFBcUIsWUFBYSxTQUFRLEtBQUssQ0FBQyxhQUFnQztJQUNyRSxNQUFNO1FBQ1QsT0FBTyw2QkFBSyxTQUFTLEVBQUUsZUFBZTtZQUNsQyw2QkFBSyxTQUFTLEVBQUUscUJBQXFCLEdBQVE7WUFDN0MsNkJBQUssU0FBUyxFQUFFLHVCQUF1QixJQUFHLFNBQUUsQ0FBQyw2QkFBNkIsQ0FBQyxDQUFPLENBQ2hGLENBQUM7SUFDWCxDQUFDO0NBQ0o7QUFQRCwrQkFPQyJ9